<template>
  <div class="">
    <v-header :inputName='Name'></v-header>
    <v-serch ref="vserch"  @search="searchName" typename="major"></v-serch>
    <saixuantop1 @select="selectType"></saixuantop1>
    <div class="xunhuan container">
      <ul :class="{'gudingo':guding}" class="" id="yuanshu1">
        <li>专业名称</li>
        <li>专业学制(年)</li>
        <li>学历</li>
        <!-- <li>男女比例</li> -->
        <li>专业收藏</li>
      </ul>
      <div   id="yuanshu2" style="min-height: 500px;">
        <div class="xh" v-for="(item,i) in list">
          <div class="kuang">
            <router-link :to="'/zyxq_zhuanyejieshao?id='+item.majorId" target="_blank"  class="a1">{{item.majorName}}</router-link>
          </div>
          <div class="kuang">
            <span>{{item.majorSystem}}</span>
          </div>
          <div class="kuang">
            <span>{{item.majorEducation==1?'本科':'专科'}}</span>
          </div>
          <!-- <div class="kuang">
					<span>{{item.bili}}</span>
				</div> -->
          <div class="kuang" @click="shou(item.majorId)">
            <router-link to="" class="a2" :class="{'wenzhis':true}" v-if="userCang.indexOf(item.majorId)==-1">收藏
              <img src="../../assets/img/xing2.png">
            </router-link>
            <router-link to="" class="a2" :class="{'wenzhis':false}" v-else>已收藏
              <img src="../../assets/img/xing1.png">
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <zuoxuanfu1></zuoxuanfu1>
    <item7></item7>
  </div>
</template>

<script>
  import vHeader from '../../components/vHeader.vue'
  import item7 from '../../components/item7.vue'
  import zuoxuanfu1 from '../../components/zuoxuanfu1.vue'
  import vSerch from '../../components/vSerch.vue'
  import saixuantop1 from '../../components/saixuantop1.vue'
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      zuoxuanfu1,
      saixuantop1,
      vSerch
    },
    data() {
      return {
        // 头固定
        guding: false,
        // 导航选中
        Name: 3,
        majorName:'',
        list: [],
        typeId: "",
        userCang:[]

      }
    },
    mounted() {
      // window.addEventListener('scroll', this.handleScroll)
      let userCang = this.$utils.getlocalStorage('userCang')
      if(userCang!=null&&userCang!=''){
        this.userCang = userCang.major
      }
      window.addEventListener('scroll', this.handleScrollx, true)
    },
    methods: {
      searchName(name) {
        this.majorName = name
        if(name == null||name == ''){
          return ;
        }
        this.typeId = '';
        this.getMajor()
      },
      handleScrollx() {
		  if(this.$route.path == '/zhuanyezhiyuan'){
			  let tedItem = document.querySelector("#yuanshu1")
			  let tedItem2 = document.querySelector("#yuanshu2")
			  var scrollTop = tedItem.getBoundingClientRect().top
			  var scrollTop2 = tedItem2.getBoundingClientRect().top
			  if (scrollTop <= 0) {
			    this.guding = true
			  }
			  if (scrollTop2 >= 52) {
			    this.guding = false
			  }
		  }

      },
      shou(id) {
      	let _this = this;
      	let flag1 = this.$utils.getLoginStatus();
      	if (flag1) {
      		let obj = this.$utils.getlocalStorage('userCang')
      		let list = obj.major
      		if (list.indexOf(id) == -1) {
      			_this.$req.insert("collectionTable", {
      				dataType: 2,
      				dataId: id,
              userId:this.$utils.getlocalStorage('userInfo').userId
      			}).then(function(resp) {
      				if (resp.status == 0) {
      					list.push(id);
      					_this.userCang = list
      					obj.major = list
      					_this.$utils.setlocalStorage("userCang", obj);
      				}
      			})

      		} else {
      			_this.$req.batchDelete("collectionTable", {
      				data_type: 2,
      				data_id: id,
              userId:this.$utils.getlocalStorage('userInfo').userId
      			}).then(function(resp) {
      				if (resp.status == 0) {
      					list.splice(list.indexOf(id), 1);
      					_this.userCang = list
      					obj.major = list
      					_this.$utils.setlocalStorage("userCang", obj);
      				}
      			})
      		}
      	}
      },
      selectType(typeId) {
        this.typeId = typeId
        this.$refs.vserch.clear();
        this.majorName = '';
        this.getMajor()
      },


      getMajor() {
        let _this = this;
        let obj = {}
        if(_this.typeId!=null&&_this.typeId!=''){
          obj.majorTypeId =  _this.typeId
        }
        if(_this.majorName!=null&&_this.majorName!=''){
          obj.majorName =  _this.majorName
        }
        this.$req.queryAllByLimit('majorTable', {
          pageNum: 1,
          pageSize: 0,
          queryObj: obj
        }).then(function(response) {
          _this.list = response.data
        })

      },
      // handleScroll () {
      //   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      //   // console.log(scrollTop)

      // },
    }


  }
</script>

<style scoped>
  .gudingo {
    position: fixed;
    top: 90px;
    left: ;
    transform: translate(0);
    margin-top: 0 !important;
    width: 1458px !important;
    z-index: 9;
  }

  /* .gudingo li{flex-shrink: 0;} */

  .xunhuan ul {
    width: 100%;
    height: 50px;
    background: rgba(246, 100, 100, 1);
    opacity: 1;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .xunhuan ul li {
    width: 25%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .kuang {
    border: 1px solid #EBE9E9;
    width: 25%;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .wenzhis {
    color: #C8C8C8 !important;
  }

  .xunhuan .a2 {
    text-decoration: none;
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    color: #FE9603;
    opacity: 1;
    display: flex;
    align-items: center;
  }

  .xunhuan .a2 img {
    margin-left: 5px;
  }

  .xunhuan .a1 {
    text-decoration: none;
    color: #29A7E1;
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    color: #29A7E1;
    opacity: 1;
  }

  .xunhuan {
    color: #666666;
    text-align: center;
    justify-content: space-evenly;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
  }

  .xh {
    display: flex;
    margin-bottom: 5px;
  }

  .container {
    width: 1280px !important;
  }
/*
  @media (max-width:750px) {
    .container {
      width: auto !important;
    }

    .gudingo li {
      flex-shrink: 0;
    }

    .gudingo li {
      width: 180px !important;
    }

    .gudingo {
      overflow-y: hidden;
      overflow-x: auto;
      justify-content: normal !important;
      width: 1458px !important;
    }

    .gudingo .T_title8 {
      width: 300px !important;
      flex-shrink: 0;
      flex: none;
    }

    .xunhuan {
      display: block;
      overflow-y: hidden;
      overflow-x: auto;
    }

    .xunhuan ul {
      width: 900px;
    }

    .xh {
      display: flex;
      width: 900px;
    }

    .kuang span {
      line-height: 63px;
    }

    .xunhuan .a2 {
      line-height: 63px;
    }

  }

  @media (min-width:1200px; ) {}

  @media (max-width:1200px; ) {} */
</style>



// WEBPACK FOOTER //
// src/views/information/major.vue